import { render, staticRenderFns } from "./StockInvoiceReferencesPanel.vue?vue&type=template&id=5173e9f0&scoped=true"
import script from "./StockInvoiceReferencesPanel.vue?vue&type=script&lang=js"
export * from "./StockInvoiceReferencesPanel.vue?vue&type=script&lang=js"
import style0 from "./StockInvoiceReferencesPanel.vue?vue&type=style&index=0&id=5173e9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5173e9f0",
  null
  
)

export default component.exports